<div class="loan-amount-grid-wrapper" data-testid="loan-amount-grid-wrapper">

  <!-- Inactive loans toggle -->
  <div class="loan-amount-grid-toolbar" *ngIf="config?.showCheckbox !== false">
    <dx-check-box class="loan-amount-grid-check-box" data-testid="loan-amount-grid-show-inactive" text="Show Inactive Loans" [value]="showInactiveLoans"
      [disabled]="isGridInEditMode || (value && value.length > 0)" (onValueChanged)="onShowInactiveChanged($event)">
    </dx-check-box>
  </div>

  <dx-data-grid data-testid="loan-amount-grid" [dataSource]="value" keyExpr="key" [columns]="columns"
    [showBorders]="true" [columnAutoWidth]="true" [rowAlternationEnabled]="true"
    (onInitialized)="onGridInitialized($event)" (onRowInserted)="onRowInserted($event)"
    (onRowUpdated)="onRowUpdated($event)" (onRowRemoved)="onRowRemoved($event)" (onEditingStart)="onEditingStart()"
    (onEditCanceled)="onEditCanceled()" (onCellPrepared)="onCellPrepared($event)"
    (onRowPrepared)="onRowPrepared($event)" (onEditorPreparing)="onEditorPreparing($event)">

    <dxo-editing mode="row" [allowAdding]="hasAvailableItems" [allowUpdating]="true" [allowDeleting]="true"
      [confirmDelete]="false" />
    <dxo-paging [enabled]="false" />
    <dxo-load-panel [enabled]="false" />
  </dx-data-grid>

</div>